import { useState } from "react";
import CarRotation from "@/app/components/CarsComponents/CarDatasheet/CarRotation";

const BASE_URL =
	"https://sablobsitestoyotaprd.blob.core.windows.net/images/move-brasil/Vehicles/yaris-cross-xr";

const XR_COLORS = [
	{
		name: "Azul",
		hex: "#2C5DF7",
		carrossel: `${BASE_URL}/Azul/Carrossel.png`,
	},
	{
		name: "Branco Cinza",
		hex: "#c8c8c8",
		carrossel: `${BASE_URL}/BrancoCinza/Carrossel.png`,
	},
	{
		name: "Branco Lunar",
		hex: "#e3e3e3",
		carrossel: `${BASE_URL}/BrancoLunar/Carrossel.png`,
	},
	{
		name: "Branco Polar",
		hex: "#FCFCFC",
		carrossel: `${BASE_URL}/BrancoPolar/Carrossel.png`,
	},
	{
		name: "Prata",
		hex: "#ACADAC",
		carrossel: `${BASE_URL}/Prata/Carrossel.png`,
	},
	{
		name: "Preto",
		hex: "#363636",
		carrossel: `${BASE_URL}/Preto/Carrossel.png`,
	},
	{
		name: "Vermelho",
		hex: "#CD383E",
		carrossel: `${BASE_URL}/Vermelho/Carrossel.png`,
	},
];

export default function VeiculoMoveBrasil() {
	const [selectedColor, setSelectedColor] = useState(XR_COLORS[2]); // Branco Lunar como padrão

	return (
		<div className="flex flex-col items-center w-full py-6">
			{/* Visualizador 360° */}
			<div className="max-w-[400px] w-full">
				<CarRotation carrossel={selectedColor.carrossel} />
			</div>

			{/* Seletor de cores */}
			<div className="flex w-full items-center justify-center gap-4 mt-2">
				{XR_COLORS.map((c) => (
					<div
						key={c.name}
						className={`w-6 h-6 rounded-full shadow shadow-black cursor-pointer transition-transform ${
							c.name === selectedColor.name ? "scale-125" : ""
						}`}
						onClick={() => setSelectedColor(c)}
						style={{ backgroundColor: c.hex }}
					/>
				))}
			</div>

			{/* Nome da cor */}
			<div className="flex gap-1.5 max-w-60 w-full justify-center items-center mt-2 text-sm text-neutral-700">
				<div className="flex-1 w-full h-[2px] bg-gradient-to-r from-neutral-100 to-neutral-400" />
				<span>{selectedColor.name}</span>
				<div className="flex-1 w-full h-[2px] bg-gradient-to-l from-neutral-100 to-neutral-400" />
			</div>
		</div>
	);
}
